 <template>
  <div class="share">
    <iModal
      title="分享"
      v-model="showModal"
      class-name="vertical-center-modal share-modal"
      width="940px"
      :mask-closable="false"
      @on-cancel="close()"
      :styles="{top: '100px'}"
    >
      <div class="share-content">
        <Form ref="formValidate" :model="formValidate" :rules="ruleInline" :label-width="100">
          <FormItem label="分享标题：" prop="title">
            <Input v-model="formValidate.title" placeholder="我是XXX，我是第N位分享的人，你也一起来吧！" />
          </FormItem>
          <FormItem label="证书附件：">
            <div class="my-upload">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" style="width: 150px;height:100px;" />
                  <div class="my-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 150px;height: 100px;">
                    <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :action="uploadUrl"
                multiple
                :before-upload="handleBeforeUpload"
                style="display: inline-block;width: 150px;"
                v-show="uploadList && uploadList.length <1"
              >
                <div style="width: 150px;height:100px;padding-top: 17px;">
                  <div style="font-size:20px">
                    +
                    <p style="font-size:14px">上传</p>
                  </div>
                </div>
                <!-- 蒙版 -->
                <div
                  style="position:absolute;opacity:0;width:150px;height:100px;left:0;top:0;"
                  @click.stop="selectType"
                ></div>
              </Upload>
            </div>
            <div class="my-upload-tip">（图片要求：2M以下的jpg或png，建议图片尺寸500X500px）</div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <!-- <a href="javascript:;" class="f-fl" style="display: inline-block;line-height: 31px;">海报下载</a> -->
        <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">保存</Button>
        <Button @click="close()">取消</Button>
      </div>
      <div class="iphone-share">
        <img style="width:auto;height:386px;" src="@assets/img/iphone-share.png" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script> 
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
export default {
  name: "look-share",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.close();
      this.setData();
    },
    editData(val, oldVal) {
      console.log(val);
      this.setData();
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formValidate: {
        title: ""
      },
      ruleInline: {
        // 效验规则
        title: [
          { required: true, message: "分享标题不能为空", trigger: "blur" },

          {
            type: "string",
            max: 28,
            message: "分享标题不能大于28位",
            trigger: "blur"
          }
        ]
      },
      defaultList: [],
      uploadList: [],
      limitNum1: 1, // 图文显示的限制图片个数
      uploadChooseShowed: false // 控制文件上传方式的显示和隐藏
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  },
  methods: {
    ...mapActions({
      putJoinExhibitionInfo: "exhibitionModule/putJoinExhibitionInfo"
    }),
    setData() {
      if (!(this.editData && this.editData.shareInfo)) return;
      let shareInfo = this.editData.shareInfo;
      this.formValidate.title = shareInfo.Title;
      if (shareInfo.Cover) {
        this.defaultList = [
          {
            name: this.editData.name,
            url: shareInfo.Cover,
            status: "finished",
            percentage: 100
          }
        ];
      }
      this.uploadList = this.defaultList;
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum1 = 1;
      const check1 = this.uploadList.length < limitNum1;
      if (!check1) {
        this.$Message.warning(`Upload ${limitNum1} image only`);
      }
      return check1;
    },
    // 移除上传图片
    handleRemove1(file) {
      const fileList1 = this.uploadList;
      this.uploadList.splice(fileList1.indexOf(file), 1);
    },
    // 查看上传图片
    handleView1(name) {},
    // 活动发布
    async handleSubmit(name) {
      let imgList1 = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传分享证书附件`);
        return;
      }
      let formData = {
        Id: this.editData.joinId,
        SetValues: {
          ShareInfo: JSON.stringify({
            Title: this.formValidate.title,
            Cover: this.uploadList[0].url
          })
        }
      };
      console.log(JSON.stringify(formData));
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let bool = await this.putJoinExhibitionInfo(formData).catch(
        e => (this.loading = false)
      );
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("修改成功");
        this.$emit("finish");
        this.close();
        if (this.$refs.upload) {
          this.$refs.upload2.clearFiles();
        }
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formValidate"]) {
        this.$refs["formValidate"].resetFields();
        this.formValidate.outLinkdes = "";
      }
      this.defaultList = [];
      this.uploadList = [];
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    }
  },
  components: {
    imgUpload
  }
};
</script>

<style lang="scss">
.share-modal {
  .ivu-modal-content {
    width: 650px;
  }
}
</style>
<style lang="scss" scoped>
.share {
  &-content {
    padding: 30px 30px 0 30px;
    .upload-p {
      font-size: 12px;
    }
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.iphone-share {
  position: absolute;
  right: -300px;
  top: 0;
}
</style>